import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import { blue } from "@mui/material/colors";

interface Props {
  hasCompetitorPresence: boolean;
  competitorPresenceIds: number[];
  competitorProductMetadata: Record<number, string>;
}
export default function CompetitorPresenceChip(props: Props) {
  const hasPresence = props.competitorPresenceIds.length > 0;
  const firstProductName =
    props.competitorPresenceIds.length > 0
      ? props.competitorProductMetadata[props.competitorPresenceIds[0]]
      : undefined;
  const isMultipleProducts = props.competitorPresenceIds.length > 1;

  const chipStyles = {
    width: 200,
    minWidth: 200,
    maxWidth: 200,
    "& .MuiChip-label": {
      width: "100%",
      paddingX: 2,
      display: "flex",
      justifyContent: "center",
    },
  };

  if (!props.hasCompetitorPresence) {
    return (
      <Chip
        label={"No Data"}
        size="small"
        sx={{ ...chipStyles, backgroundColor: "transparent" }}
      />
    );
  }

  if (!hasPresence) {
    return (
      <Chip
        label="None"
        size="small"
        sx={{ ...chipStyles, backgroundColor: blue[50] }}
      />
    );
  }

  // For single product, just show the name with ellipsis but centered
  if (!isMultipleProducts) {
    return (
      <Chip
        label={firstProductName || "Unknown"}
        size="small"
        sx={{
          ...chipStyles,
          backgroundColor: blue[50],
          "& .MuiChip-label": {
            width: "100%",
            paddingX: 2,
            textAlign: "center",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          },
        }}
      />
    );
  }

  // For multiple products, show name with ellipsis and +X
  const additionalCount = props.competitorPresenceIds.length - 1;
  const suffix = `+${additionalCount}`;

  // Use flex to keep items together but ensure +X is always visible
  const label = (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <Box
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          maxWidth: `calc(100% - ${suffix.length * 8 + 8}px)`, // Reserve space for +X
        }}
      >
        {firstProductName || "Unknown"}
      </Box>
      <Box
        sx={{
          flexShrink: 0,
          ml: 0.5,
        }}
      >
        {suffix}
      </Box>
    </Box>
  );

  return (
    <Chip
      label={label}
      size="small"
      sx={{ ...chipStyles, backgroundColor: blue[50] }}
    />
  );
}
